import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import {
  deleteSessionNotification,
  editSessionNotification,
  getSessionNotification,
  saveSessionNotification,
} from "../../redux/Headcount/SessionNotification/actions";
import CheckJefe from "../../components/HeadCount/CheckJefe";
import CheckColaboradores from "../../components/HeadCount/CheckColaboradores";
import { getClassification } from "../../redux/Classification/actions";

const SessionNotification = (props) => {
  // const filters = [
  //   { id: "clasificacion", desc: "Clasificación" },
  //   { id: "Jefe", desc: "Jefe" },
  //   { id: "colaboradores", desc: "Colaboradores" },
  //   { id: "dias", desc: "Dias" },
  // ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  // const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    clasificacion: Yup.string().required("**Campo requerido"),
    dias: Yup.number()
      .integer("El campo no debe llevar decimales")
      .min(0, "Debe ingresar un número positivo.")
      .required("**Campo requerido"),
    jefes: Yup.boolean().notRequired(""),
    Colaboradores: Yup.boolean().notRequired(""),
  });

  const {
    loading,
    saveLoading,
    sessionNotification,
    sessionNotificationError,
    formError,
  } = useSelector((store) => store.sessionNotification);
  const pages = Math.ceil(
    sessionNotification ? sessionNotification.count / limit : 0
  );

  const { classification, loading: loadingClasificacion } = useSelector(
    (store) => store.classification
  );

  const columns = [
    {
      Header: "Clasificación",
      accessor: "clasificacion",
      Filter: "",
      Cell: (value) => (
        <div>{value.row.original.clasificacion_list[0].nombre}</div>
      ),
    },
    {
      Header: "Jefes",
      accessor: "jefes",
      Filter: "",
      Cell: (value) => (
        <Col>
          <CheckJefe value={value.row.original} index={value.row.index} />
        </Col>
      ),
    },
    {
      Header: "Colaboradores",
      accessor: "colaboradores",
      Filter: "",
      Cell: (value) => (
        <Col>
          <CheckColaboradores
            value={value.row.original}
            index={value.row.index}
          />
        </Col>
      ),
    },
    {
      Header: "Días",
      accessor: "dias",
      Filter: "",
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const _getSessionNotification = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getSessionNotification({
        offset: offs,
        limit: lim,
        // tipo_busqueda: tipoBusqueda.id,
        // filter: filt,
      })
    );

  useEffect(() => {
    _getSessionNotification();
    dispatch(getClassification({}, 2));
  }, []);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getSessionNotification(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    if (!edit) {
      dispatch(saveSessionNotification(req, setShowModal));
    } else {
      dispatch(editSessionNotification(req, editItem.id, index, setShowModal));
    }
  };

  // const seeAll = () => {
  //   const oSearch = "";
  //   setFilter(oSearch);
  //   const oOffset = 0;
  //   setOffset(oOffset);
  //   setCurrentPage(1);
  //   _getSessionNotification(oOffset, limit, oSearch);
  // };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteSessionNotification(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Notificaciones de no ingreso
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                {/* <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col> */}
                {/* <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <ButtonGroup>
                    {/* <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button> */}
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    {/* <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown> */}
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            sessionNotification &&
            sessionNotification.count > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={sessionNotification.data}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={sessionNotification.count}
                  pages={pages}
                  pagFunc={_getSessionNotification}
                />
              </>
            )
          )}
          {!loading &&
            sessionNotification &&
            sessionNotification.count === 0 &&
            sessionNotificationError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!sessionNotificationError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {sessionNotificationError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            clasificacion: edit ? editItem.clasificacion : "",
            dias: edit ? editItem.dias : "",
            jefes: edit ? editItem.jefes : false,
            colaboradores: edit ? editItem.colaboradores : false,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar notificaciones" : "Crear notificaciones"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Clasificación
                  </Form.Label>
                  <Row className="d-flex flex-wrap justify-content-start align-items-center">
                    <Col sm={loadingClasificacion ? "10" : "12"}>
                      <Form.Control
                        as="select"
                        id="clasificacion"
                        name="clasificacion"
                        className="col rounded-pill"
                        isInvalid={
                          touched.clasificacion && errors.clasificacion
                        }
                        isValid={touched.clasificacion && !errors.clasificacion}
                        onBlur={handleBlur("clasificacion")}
                        value={values.clasificacion}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                      >
                        <option
                          className="text-muted"
                          value=""
                          selected
                          disabled
                        >
                          Selecionar clasificacion
                        </option>
                        {classification
                          ? classification.length > 0 &&
                            classification
                              .sort((a, b) =>
                                a.nombre > b.nombre
                                  ? 1
                                  : b.nombre > a.nombre
                                  ? -1
                                  : 0
                              )
                              .map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.nombre ? item.nombre : ""}
                                </option>
                              ))
                          : ""}
                      </Form.Control>
                      {touched.clasificacion && errors.clasificacion && (
                        <Col>
                          <small className="text-danger">
                            {errors.clasificacion}
                          </small>
                        </Col>
                      )}
                    </Col>
                    {loadingClasificacion ? (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    ) : null}
                  </Row>
                  {touched.nombre && errors.nombre && (
                    <div>
                      <small className="text-danger">{errors.nombre}</small>
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Días
                  </Form.Label>
                  <Form.Control
                    id="dias"
                    name="dias"
                    isInvalid={touched.dias && errors.dias}
                    isValid={touched.dias && !errors.dias}
                    onBlur={handleBlur("dias")}
                    onChange={handleChange}
                    value={values.dias}
                    className="rounded-pill"
                    type="number"
                    placeholder="Días"
                  ></Form.Control>
                  {touched.dias && errors.dias && (
                    <Col>
                      <small className="text-danger">{errors.dias}</small>
                    </Col>
                  )}
                </Form.Group>
                <Form.Group as={Col} className="mx-2 my-3">
                  <div className="d-flex aling-items-center justify-content-between pl-2 pr-3 pt-3">
                    <label htmlFor="active">Jefes</label>
                    <Form.Check
                      id="jefes"
                      name="jefes"
                      isInvalid={touched.jefes && errors.jefes}
                      isValid={touched.jefes && !errors.jefes}
                      onBlur={handleBlur("jefes")}
                      onChange={(e) => {
                        setFieldValue("jefes", e.target.checked);
                      }}
                      value={values.jefes}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={edit ? editItem.jefes : null}
                    />
                    {touched.jefes && errors.jefes && (
                      <Col>
                        <small className="text-danger">{errors.jefes}</small>
                      </Col>
                    )}
                  </div>
                </Form.Group>
                <Form.Group as={Col} className="mx-2 my-3">
                  <div className="d-flex aling-items-center justify-content-between pl-2 pr-3 pt-3">
                    <label htmlFor="active">Colaboradores</label>
                    <Form.Check
                      id="colaboradores"
                      name="colaboradores"
                      isInvalid={touched.colaboradores && errors.colaboradores}
                      isValid={touched.colaboradores && !errors.colaboradores}
                      onBlur={handleBlur("colaboradores")}
                      onChange={(e) => {
                        setFieldValue("colaboradores", e.target.checked);
                      }}
                      value={values.colaboradores}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={edit ? editItem.colaboradores : null}
                    />
                    {touched.colaboradores && errors.colaboradores && (
                      <Col>
                        <small className="text-danger">
                          {errors.colaboradores}
                        </small>
                      </Col>
                    )}
                  </div>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default SessionNotification;
